import React, { useEffect, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Menu, Image,Dropdown as SemanticDropDown,Header, Icon  } from 'semantic-ui-react';
import { endpoint } from  '../../api/http';
import { Images } from '../../assets/assets';
import {GetGuests} from "../../api/services/crm";
import {GetRooms} from "../../api/services/pms";
import LanguageContext from '../../language';
import DropDown from "../../components/shared/dropdown";
import { onError } from '../../components/shared/messages'
import {ApartmentImages} from "../../assets/assets";
import { isBrowser, isMobileOnly } from 'mobile-device-detect';
import "./styles.less";

const isReceptionAnywhere = new URLSearchParams(window.location.search).get("receptionAnywhere") === "true";
const ApartmentOwnersPortalMenu = ({user, setApartmentOwner, apartmentOwner, updateHotelAndApartment}) => {
    const language = useContext(LanguageContext)
    
    const text = key=>{
        return language?language.texts[key]:key
    }
    useEffect(() => {
        if(user && user.Id){
            (async () => {
                try {
                    let guests = await GetGuests({UserIDs: [user.Id], IncludeApartmentOwnerSettings: true});
                    if(guests == null || guests.length == 0){
                        onError("No guests were found for this user")
                    }
                    else{
                        setApartmentOwner(guests[0]);
                    }
                    
                } catch (error) {
                    console.error(error)
                }
            })()
        }
    }, [user])

    const OnLogoutClicked = () => {
        if (window.optima && window.optima.utils) {
            window.optima.utils.PostMessage({ eventType: 'Logout' });
        }
    }

    const renderImage = (item) => {
        var imageBase64 = item.MainImageBase64;
        if(imageBase64){
            return `data:image/jpeg;base64,${imageBase64}`;
        }
        return ApartmentImages.defaultApartment;
    }

    const spec = useMemo(()=> {
            return {
                IncludeRoomLocation: true, 
                IncludeImages: true,
                OwnerGuestIDs: [apartmentOwner && apartmentOwner.Id], 
                IsAllChainRoomsUnderCurrentChain: true,
                IsEncodeImagesToBase64: true,
                IsForceCacheRefresh: true
            }
        }, [apartmentOwner]
    )

    return (
        <div className="apartment-menu"> 
             <Menu borderless activeIndex="-1" size="small" >
                 {isBrowser &&
                    <Menu.Item key='logo'>
                        <Image src={Images.logo} size="mini" ></Image> 
                    </Menu.Item>
                 }
                 {isMobileOnly &&
                    <SemanticDropDown simple item trigger={
                        <Icon name="bars" size="large"/>                   
                    }>
                        <SemanticDropDown.Menu>
                            {apartmentOwner && <Menu.Item link href={`${endpoint}Organization/User/Edit?isUserProfile=true&userID=${user.Id}&apartmentOwnerPortal=true`}>{text("Profile")}</Menu.Item>}
                            {isReceptionAnywhere?
                                <Menu.Item link href={`${endpoint}PMS/ReceptionAnywhere`}>{text("ReceptionAnywhere")}</Menu.Item>
                            :
                                <Menu.Item link href={`${endpoint}PMS/ApartmentOwnersPortal`}>{text("ApartmentOwnersPortal")}</Menu.Item>
                            }
                            <Menu.Item link href={`${endpoint}Organization/Account/LogOut`} onClick={OnLogoutClicked}>{text("LogOut")}</Menu.Item>
                        </SemanticDropDown.Menu>
                    </SemanticDropDown>
                }
                    <Menu.Item>
                        <Header as='h3'>{isReceptionAnywhere? text("ReceptionAnywhere"): text("OwnerPortal")}</Header>
                    </Menu.Item>
                    
                    <Menu.Menu position="right">
                        {apartmentOwner && apartmentOwner.Id &&
                            <DropDown
                                className="apartment-owners-rooms"
                                search 
                                api={GetRooms} 
                                spec={spec} 
                                textField="Name" 
                                descriptionField={isBrowser ? "Description" : ""}
                                imageField={renderImage}
                                valueField="Id" 
                                selectFirst={true}
                                onChangeItem={updateHotelAndApartment}
                                direction={"left"}
                                style={{minWidth: isBrowser ? 200 : 0}}
                            />
                        }
                        {isBrowser &&
                            <SemanticDropDown simple item trigger={
                                <div>
                                    <Image src={Images.login_avatar} avatar size="mini" />
                                    {user && <span style={{verticalAlign: "middle"}}>{user.UserName}</span>}
                                </div>
                                
                            }>
                                <SemanticDropDown.Menu>
                                    {apartmentOwner && <Menu.Item link href={`${endpoint}Organization/User/Edit?isUserProfile=true&userID=${user.Id}&apartmentOwnerPortal=true`}>{text("Profile")}</Menu.Item>}
                                    {isReceptionAnywhere?
                                        <Menu.Item link href={`${endpoint}PMS/ReceptionAnywhere`}>{text("ReceptionAnywhere")}</Menu.Item>
                                    :
                                        <Menu.Item link href={`${endpoint}PMS/ApartmentOwnersPortal`}>{text("ApartmentOwnersPortal")}</Menu.Item>
                                    }
                                    <Menu.Item link href={`${endpoint}Organization/Account/LogOut`} onClick={OnLogoutClicked}>{text("LogOut")}</Menu.Item>
                                </SemanticDropDown.Menu>
                            </SemanticDropDown>
                        }
                    </Menu.Menu>
                </Menu>
          </div>
    )
}
ApartmentOwnersPortalMenu.propTypes = {
    user: PropTypes.object,
    updateHotelAndApartment: PropTypes.func,
    setApartmentOwner: PropTypes.func,
    apartmentOwner: PropTypes.object
}
export default ApartmentOwnersPortalMenu